import { render } from "./LihatRiwayatTutupOutletModal_c.vue?vue&type=template&id=7b96a92c"
import script from "./LihatRiwayatTutupOutletModal_c.vue?vue&type=script&lang=js"
export * from "./LihatRiwayatTutupOutletModal_c.vue?vue&type=script&lang=js"
script.render = render

export default script